import config from 'config';
import { CycleGuideTracking } from 'core/middlewares/trackingGA4';
import { ResellerAvailableCatalogs } from 'core/services/bff';

export const dataLayerUpdate = ({ event_parameters, ecommerce, event }: CycleGuideTracking) =>
  dataLayer.push({
    event,
    event_parameters: {
      cd_section: 'ciclo-atual',
      cd_interaction_detail: event_parameters.cd_interaction_detail,
      ...(event_parameters.event_name && { event_name: event_parameters.event_name }),
    },
    ...(ecommerce && { ecommerce }),
  });

export const catalogButtonClick = (
  selectedGuide: ResellerAvailableCatalogs,
  interactionDetail: string,
) => {
  dataLayerUpdate({
    event: 'select_promotion',
    ecommerce: {
      creative_name: selectedGuide?.link,
      creative_slot: `${selectedGuide?.position}`,
      promotion_id: `${config.app.short}-${selectedGuide?.cycleId}`,
      promotion_name: selectedGuide?.name,
    },
    event_parameters: {
      cd_interaction_detail: interactionDetail,
      cd_section: 'ciclo-atual',
    },
  });
};
